import React, { useEffect, useCallback, useState } from 'react';
import LabelsFilters from '../../components/labelsFilters';
import LabelsListing from '../../components/labelsListing';
import MainHeading from '../../components/mainHeading';
import Loadingtext from '../../components/loading';
import { useDispatch, useSelector } from 'react-redux';
import Localize from '../../utils/string';
import { getLabels } from '../../store/labels/labelsAsyncActions';
import { LabelsMdl } from "../../Modal/Labels";
import { setLoading } from '../../store/common/commonActions';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { storeLabels } from '../../store/labels/labelsActions';

const dataFilters = [
    { id: 1, filter: 'ALL' },
    { id: 2, filter: 'A' },
    { id: 3, filter: 'B' },
    { id: 4, filter: 'C' },
    { id: 5, filter: 'D' },
    { id: 6, filter: 'E' },
    { id: 7, filter: 'F' },
    { id: 8, filter: 'G' },
    { id: 9, filter: 'H' },
    { id: 10, filter: 'I' },
    { id: 11, filter: 'J' },
    { id: 12, filter: 'K' },
    { id: 13, filter: 'L' },
    { id: 14, filter: 'M' },
    { id: 15, filter: 'N' },
    { id: 16, filter: 'O' },
    { id: 17, filter: 'P' },
    { id: 18, filter: 'Q' },
    { id: 19, filter: 'R' },
    { id: 20, filter: 'S' },
    { id: 21, filter: 'T' },
    { id: 22, filter: 'U' },
    { id: 23, filter: 'V' },
    { id: 24, filter: 'W' },
    { id: 25, filter: 'X' },
    { id: 26, filter: 'Y' },
    { id: 27, filter: 'Z' },
    { id: 28, filter: '0 - 10' },
];

const Labels = () => {
    const dispatch = useDispatch();
    const [isLoading,setIsLoading] = useState<boolean>(false);
    const Location = useLocation();
    const [name, setName] = useState('0');
    // const label_value: any = useSelector(
    //     (state: any) => state.products.releases_enums_values
    // );
    const Loading = useSelector((state: any) => state.common.loading);
    const LabelData: LabelsMdl[] = useSelector((state: any) => state.labels.labels);
    useEffect(() => {
        dispatch(setLoading(true));
        setIsLoading(true);
    }, [name])
    function alphabetPosition(text: any) {
        var result = "";
        for (var i = 1; i <= text.length; i++) {
            var code = text.toUpperCase().charCodeAt(i)
            if (code > 64 && code < 91) result += (code - 64) + " ";
        }

        return result.slice(0, result.length - 1);
    }


    useEffect(() => {
        const queryParams: any = new URLSearchParams(Location.search);
        if (queryParams !== null) {
            setName(queryParams.get('name') ?? "");
        } else {
            setName("");
        }
    }, [Location])

    const initialFunction: any = useCallback(() => {

        if (name !== '0') {
            if (isMobile || (name !== '')) {
                scrollToTop()
            }
            const nameFilter = (name === 'ALL') ? '' : (name === '0 - 10' ? 'number' : name)
            const Qparams = nameFilter === "" ? "" : "?name=" + nameFilter
            dispatch(getLabels(Qparams,setIsLoading))

        }
    }, [dispatch, name])

    useEffect(() => {
        dispatch(storeLabels([]));
        initialFunction()
        // document.title = 'Labels - Prime Direct Distribution';
    }, [initialFunction])
    const [isMobile, setIsMobile] = useState<boolean>(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 991); // Adjust the width as per your requirement
        };

        handleResize(); // Check on initial render
        window.addEventListener('resize', handleResize); // Add event listener for window resize

        return () => {
            window.removeEventListener('resize', handleResize); // Cleanup event listener on component unmount
        };
    }, []);
    const scrollToTop = () => {

        const top = document.getElementById("top") as HTMLElement;
        top.scrollIntoView();

    };
    return (
        <div className="labels" id='top'>
            <Helmet>
                <title>{'Label'}</title>
                <meta name="description" content={'Full list with an easy drill down to every release linked to each label.'} />
                <meta property="og:title" content={'Label'} />
                <meta property="og:description" content={'Full list with an easy drill down to every release linked to each label.'} />
            </Helmet>
            <MainHeading text={Localize.LabelsHeading} />
            <LabelsFilters dataFilters={dataFilters} filter={name} />
            {isLoading ?
                <Loadingtext />
                :
                <div className='labelslisting-wrap' >
                    {LabelData?.map((item: any, index: number) => {
                        var textString: any = item?.alphabet === " " ? "@" : item.alphabet;
                        return (
                            <div className='labelslisting-parent' id='#scrollDemo' key={`labelcharacter_${index}`}>
                                <LabelsListing text={textString} listData={item.labelList} />
                            </div>
                        )
                    }
                    )
                    }
                </div>
            }
        </div >
    )
}

export default Labels;